module.exports = __webpack_public_path__ + "static/yae-miko-banner-2195b3a52604aba9c9f6c3abffcc45b7.png";